import { t } from "i18next";

type TooltipContent = {
    message: string;
    tooltipTitle: string;
    tooltipBody: string;
    linkUrl: string;
};

type TooltipOptions = {
    isValid?: boolean;
    noScoreReference?: boolean;
    content: {
        label: string;
        value: number;
        ssqUrl: string;
        unit: string;
    };
};

export const buildIngredientsDataTooltip = (options: TooltipOptions): TooltipContent => {
    const { isValid, noScoreReference, content } = options;

    if (isValid === false) {
        return {
            message: t("product.ingredient_nonmonolithic_no_reference.message"),
            tooltipTitle: t("product.ingredient_nonmonolithic_no_reference.title"),
            tooltipBody: t("product.ingredient_nonmonolithic_no_reference.body"),
            linkUrl: content.ssqUrl,
        };
    }

    if (noScoreReference) {
        return {
            message: t("product.ingredient_nonmonolithic_reference_without_score.message"),
            tooltipTitle: t("product.ingredient_nonmonolithic_reference_without_score.title"),
            tooltipBody: t("product.ingredient_nonmonolithic_reference_without_score.body"),
            linkUrl: content.ssqUrl,
        };
    }

    return {
        message: t("product.ingredient_nonmonolithic_reference_with_score.message"),
        tooltipTitle: t("product.ingredient_nonmonolithic_reference_with_score.title"),
        tooltipBody: t("product.ingredient_nonmonolithic_reference_with_score.body", {
            ingredient: content.label,
            value: content.value,
            unit: content.unit,
        }),
        linkUrl: content.ssqUrl,
    };
};
